import React from "react";

import {
  PollMetaWrapper,
  NumberOfVotes,
  MidDot,
  PollTimeRemaining,
  PollProgressBars,
  PollProgressBarWrapper,
  ProgressBar,
  ProgressValue,
  Option,
  Percentage,
} from "./style";

const Poll = ({ votes, pollOptions, pollDurationData, onClick }) => {
  return (
    <>
      <PollProgressBars>
        {pollOptions?.map(({ voting_percentage, title }, index) => (
          <PollProgressBarWrapper key={index} onClick={onClick}>
            <ProgressBar />
            <ProgressValue style={{ width: `${voting_percentage}%` }} />
            <Option variant="paragraph4">{title}</Option>
            <Percentage variant="paragraph4">{voting_percentage}%</Percentage>
          </PollProgressBarWrapper>
        ))}
      </PollProgressBars>
      <PollMetaWrapper>
        <NumberOfVotes variant="paragraph4">{votes} Voted</NumberOfVotes>
        <MidDot variant="paragraph4">&middot;</MidDot>
        <PollTimeRemaining
          variant="paragraph4"
          style={{ color: pollDurationData.text_color }}
        >
          {pollDurationData.text}
        </PollTimeRemaining>
      </PollMetaWrapper>
    </>
  );
};

export default Poll;
